/**
 * VyV Conseil MRH Public API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.3
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Type de document associé au contrat
 */
export type VyVContractDocumentType = 'CP' | 'FIC' | 'SEPA' | 'ATT_MRH' | 'CG';

export const VyVContractDocumentType = {
  CP: 'CP' as VyVContractDocumentType,
  FIC: 'FIC' as VyVContractDocumentType,
  SEPA: 'SEPA' as VyVContractDocumentType,
  ATT_MRH: 'ATT_MRH' as VyVContractDocumentType,
  CG: 'CG' as VyVContractDocumentType
};
